export enum CenterOnOffPilot {    
    Off = 0,
    Pilot = 1,
    On = 2
}